import { render, staticRenderFns } from "./sidebar.svg?vue&type=template&id=3f72bd03"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports